import {
  withTranslation,
} from 'react-i18next';

import RegattasListItemView from './RegattasListItemView';
import './RegattasListItem.css';

const TranslatedComponent = withTranslation()(RegattasListItemView);

const Component = TranslatedComponent;

export default Component;
